/** store cooket */
function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

/** get cooket value by cookie name*/
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function closeOTPPopup() {
  var otpPopupHtml = document.getElementsByTagName( 'html' )[0];
  var otpPopupElement = document.getElementById('verifyOTPPopup');

  if (otpPopupElement) {
      // Remove the class from the element
      otpPopupHtml.classList.remove('popup-overlap');

      // Set display property to 'none'
      otpPopupElement.style.display = 'none';
  } else {
      console.error("Element with ID 'otppopup' not found");
  }
}

function validateAndSwitch(input, nextFieldId) {
  // Remove non-numeric characters
  input.value = input.value.replace(/[^0-9a-zA-Z]/g, '');

  // Ensure only one character is entered
  if (input.value.length > 1) {
      input.value = input.value.charAt(0);
  }

  // Switch focus to the next input field
  if (input.value.length === 1 && nextFieldId) {
      document.getElementById(nextFieldId).focus();
  }

  // Check if all input fields are filled
  var allInputsFilled = Array.from(document.querySelectorAll('.your-input-class')).every(function (input) {
      return input.value.length === 1;
  });

  // Enable or disable the submit button based on the status of all input fields
  document.getElementById('verifyOtpbtn').disabled = !allInputsFilled;
}

function sendOTP(mobileNo) {
  var formdata = new FormData();
  formdata.append("mobileNo", mobileNo);
  formdata.append("isContinue", "0");

  return fetch(`https://alainappuat.gdadmin.org/shopifyApiV2/loginCustomer`, {
        method: 'POST',
        headers:{
            'lancode':'en',
            'token':'123456',
        },
        body:formdata
    }).then(response => {
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();  
    }).then(data => {
        return data;
    }).catch(error => {
        console.error('Send OTP Error fetching data:', error);
    });
}

function captureMobileNumber() {
  // Get the input value
  var mobileNumber = document.getElementById("mobile").value;

  // Update the content of the div with the id "capturedValue"
  document.getElementById("capturedValue").innerText = mobileNumber;
  document.getElementById("capturedValuemob").innerText = mobileNumber;  
}
class RegisterCustomer extends HTMLElement{
  constructor(){
    super();
    this.openMapPopup = this.querySelector('#openMapPopup');
    this.registerBtn = this.querySelector("#regi_button");
    this.verifyOtpBtn = this.querySelector("#verifyOtpbtn");
    this.resendLink = this.querySelector('#resendLink');
    this.accept_condition = this.querySelector('#accept_condition');
    this.first_name = this.querySelector('[name="customer[first_name]"]');
    this.last_name = this.querySelector('[name="customer[last_name]"]');
    this.phone = this.querySelector('[name="phone"]');
    this.customer_email = this.querySelector('.field .customer_email');
    this.address1 = this.querySelector('[name="addressInput"]');
    this.address2 = this.querySelector('.address2');
    this.city = this.querySelector('[name="city"]');
    this.district = this.querySelector('[name="district"]');
    this.lastOTPDigit = this.querySelector('#OneTimePassword6');
    this.getCity();
    this.evenetListener();
  }
  async evenetListener() {
    this.lastOTPDigit.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        this.verifyOtpBtn.click();
      }
    });
    this.phone.addEventListener('change', e => {
      // Remove non-numeric characters
      this.numericValue = this.phone.value.replace(/\D/g, '');

      // Update the input value with the numeric value
      this.phone.value = this.numericValue;
    });

    this.openMapPopup.addEventListener('click', e => {
      openMapPopup();
    });

    this.city.addEventListener('change', e => {
      this.switchDistricts(this.city.value);
    });

    this.accept_condition.addEventListener('change', e => {
      if (this.accept_condition && this.registerBtn) {
        this.registerBtn.disabled = !this.accept_condition.checked;
      } else {
          console.error("Checkbox or button not found");
      }
    });

    this.registerBtn.addEventListener('click', e => {
      console.log('regi clicked');
        e.preventDefault();
        this.numericValue = this.phone.value.replace(/\D/g, '');
        let isValidate = this.validateForm();
        if (this.numericValue.length === 9 && isValidate) { 
          sendOTP(this.phone.value).then(response=>{
            console.log('Send OTP',response);
            // if(response.response.isExist == 1){
            //   this.querySelector('#mobileError').innerText = "Mobile number has already been taken.";
            // }else{
              this.initVerifyPopup();
              this.startTimer()
            // }
          });
        }
    });
    this.resendLink.addEventListener('click', e => {
      this.resendLink.classList.add('disabled-link');
      this.startTimer();
      sendOTP(this.phone.value).then(response => {
        console.log('Resend OTP',response);
      });
    });

    this.verifyOtpBtn.addEventListener('click', e => {
      let OTP = this.querySelector('#OneTimePassword1').value+this.querySelector('#OneTimePassword2').value+this.querySelector('#OneTimePassword3').value+this.querySelector('#OneTimePassword4').value+this.querySelector('#OneTimePassword5').value+this.querySelector('#OneTimePassword6').value;
      var formdata = new FormData();
      formdata.append("mobileNo", this.phone.value);
      formdata.append("otp", OTP);
      fetch(`https://alainappuat.gdadmin.org/shopifyApiV2/verifyOtp`, {
        method: 'POST',
        headers:{
          'lancode':'en',
          'token':'123456'
        },
        body:formdata,
      })
      .then(response => {
        if (!response.ok) {
          this.querySelector("#invalidOTPError").innerText = "Invalid OTP.";
          throw new Error(`Network response was not ok: ${response.status}`);          
        }
        return response.json();
      })
      .then(data => {
        console.log('Verified OTP',data);
        if(Array.isArray(data.response)){
          this.registerCustomer();
        }else{
          this.querySelector("#invalidOTPError").innerText = "Invalid OTP.";
        }
      }).catch(error => {
        console.log('Fetching error verify OTP',error);
      });
    });
  }
  registerCustomer() {
    const customerData = JSON.stringify({
      first_name: this.first_name.value,
      last_name: this.last_name.value,
      email: this.customer_email.value,
      phone: this.phone.value,
      address1: this.address1.value,
      address2: this.address2.value,
      city: this.city.options[this.city.selectedIndex].text,
      district: this.district.options[this.district.selectedIndex].text});
    fetch('https://alainuat.gdadmin.org/laravel/public/api/customer/register', {
      method: 'POST',
      body:customerData,
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      let responce = JSON.parse(data.customer);
      console.log('Customer',responce);
      // let token = JSON.parse(data.token);
      console.log('Token',data.token);
      closeOTPPopup();
      if(responce.errors){
          if(responce.errors.email)
            document.getElementById('emailError').innerText = "Email has already been taken.";
          else if(responce.errors.phone)
            this.querySelector('#mobileError').innerText = responce.errors.phone;
      }else{
        window.location.href = `/account/login/multipass/${data.token}`;
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  }
  initVerifyPopup() {
    this.html = document.getElementsByTagName('html')[0];
    this.verifyOTPPopup = this.querySelector('#verifyOTPPopup');

    if (this.verifyOTPPopup) {
        // Set display property to 'block'
        this.verifyOTPPopup.style.display = 'block';

        // Add a class to the element
        this.html.classList.add('popup-overlap');
    } else {
        console.error("Element with ID 'otppopup' not found");
    }
  }
  startTimer() {
    var timeLeft = 60;
    var timerElement = document.getElementById('timer');
    var timer = setInterval(function () {
        let minutes = Math.floor(timeLeft / 60);
        let seconds = timeLeft % 60;
        let formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        timerElement.textContent = formattedTime;
        if (--timeLeft <= 0) {
            clearInterval(timer);
            // Enable the link and reset onclick when the timer finishes
            document.getElementById('resendLink').classList.remove('disabled-link');
            timerElement.style.display = 'none';
        }else{
          timerElement.style.display = 'block';
        }
    }, 1000);
  }
  validateForm(){
    console.log('Validate form');
    this.isValid = false;

    this.first_name_valid = this.validateField('first_name', 'firstNameError', 'Please enter your First Name.');
    this.last_name_valid = this.validateField('last_name', 'lastNameError', 'Please enter your Last Name.');
    this.phone_valid = this.validatePhone('mobile', 'mobileError', 'Please enter a valid phone number.');
    this.email_valid = this.validateEmailField('email', 'emailError', 'Please enter a valid Email Address.');
    this.confirm_email_valid = this.validateConfirmEmailField('confirm_email', 'email', 'confirmEmailError', 'Email Addresses does not match.');
    this.address_valid = this.validateField('locationInput', 'locationInputError', 'Please enter your Address.');
    this.city_valid = this.validateSelectField('regi_city', 'regiCityError', 'Please select your City.');
    this.district_valid = this.validateSelectField('district', 'districtError', 'Please select your District.');

    this.isValid = this.first_name_valid && this.last_name_valid && this.phone_valid && this.email_valid && this.confirm_email_valid && this.address_valid && this.city_valid && this.district_valid;

    console.log('Form validation result:', this.isValid); // Add this line for debugging

    return this.isValid;
  }
  validatePhone(inputId, errorId, errorMessage){
    console.log('Validate phone');
    // Get and trim phone number input
    this.input = document.getElementById(inputId);
    this.errorElement = document.getElementById(errorId);
    this.value = this.input.value.trim();

    // Regex pattern for 10-digit phone number
    const pattern = /^\d{9}$/;

    // Validate phone number and update message
    const isValid = pattern.test(this.value);
    if(this.value != '' && isValid){
      this.errorElement.innerHTML = '';       
      return true; 
    }else{
      this.errorElement.innerHTML = errorMessage;
      console.error(errorMessage);
      return false;
    }
  }
  validateField(inputId, errorId, errorMessage){
    console.log('Validate field');
    this.input = document.getElementById(inputId);
    this.errorElement = document.getElementById(errorId);
    this.value = this.input.value.trim();

    if (this.value === '') {
        this.errorElement.innerHTML = errorMessage;
        console.error(errorMessage);
        return false;
    } else {
        this.errorElement.innerHTML = '';       
        return true;      
    }
  }
  validateEmailField(inputId, errorId, errorMessage) {
    this.input = document.getElementById(inputId);
    this.errorElement = document.getElementById(errorId);
    this.email = this.input.value.trim();

    if (this.email === '' || !this.isValidEmail(this.email)) {
        this.errorElement.innerHTML = errorMessage;
        console.error(errorMessage);
        return false;
    } else {
        this.errorElement.innerHTML = '';
        return true;
    }
  }
  isValidEmail(email) {
    // More permissive email validation regex
    this.emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    return this.emailRegex.test(email);
  }
  validateConfirmEmailField(inputId, referenceInputId, errorId, errorMessage) {
    this.input = document.getElementById(inputId);
    this.errorElement = document.getElementById(errorId);
    this.confirmEmail = this.input.value.trim();
    this.referenceEmail = document.getElementById(referenceInputId).value.trim();

    if (this.confirmEmail === '' || this.confirmEmail !== this.referenceEmail) {
        this.errorElement.innerHTML = errorMessage;
        console.error(errorMessage);
        return false;
    } else {
        this.errorElement.innerHTML = '';
        return true;
    }
  }
  validateSelectField(inputId, errorId, errorMessage) {
    // alert(errorId);
      this.input = document.getElementById(inputId);
      this.errorElement = document.getElementById(errorId);
      this.value = this.input.value;
  
      if (this.value === '' || this.value === 'Select your city' || this.value === 'Select your district') {
          this.errorElement.innerHTML = errorMessage;
          console.error(errorMessage);
          return false;
      } else {
          this.errorElement.innerHTML = '';
          return true;
      }
  }
  getCity() {
    fetch('https://alainappuat.gdadmin.org/shopifyApiV3/getCityDistricts/',{
        method: 'GET',
        headers:{
            'lancode':'en',
            'token':'123456'
        }
    })
    .then(response => response.json())
    .then(data => {
      let options = ["<option>Select your city</option>"];

      data.response.forEach(city => {
        options.push(`<option id="city_${city.id}" value="${city.id}">${city.city_name}</option>`);
      });
      // this.city.querySelector('option').remove();
      this.city.insertAdjacentHTML('afterbegin', options.join(''));
    })
    .catch(error => {
      console.error('Error fetching city:', error);
    });
  }
  switchDistricts(city) {
    fetch(`https://alainappuat.gdadmin.org/shopifyApiV3/getCityDistricts/${city}`,{
          method: 'GET',
          headers:{
              'lancode':'en',
              'token':'123456'
          }
      })
      .then(response => response.json())
      .then(data => {
        let options = [];

        data.response.forEach(district => {
          options.push(`<option id="district_${district.id}" value="${district.id}">${district.district_name}</option>`);
        });
        this.district.querySelector('option').remove();
        this.district.insertAdjacentHTML('afterbegin', options.join(''));
      })
      .catch(error => {
        console.error('Error fetching city:', error);
      });
  }
}
customElements.define('register-customer', RegisterCustomer);


class LoginCustomer extends HTMLElement {
  constructor() {
    super();
    this.customLoginElement = this.querySelector('.otp-container');
    this.customLoginotpElement = this.querySelector('.custom_login_container');
    this.customEmailElement = this.querySelector('.custom_email_container');
    this.verifyMobileBtn = this.querySelector('#verifyMobile');
    this.verifyOtpLoginBtn = this.querySelector('.verifyOtpLoginBtn');
    this.resendBtn = this.querySelector('#resendLink'); 
    this.updateEmailBtn = this.querySelector('#updateEmailBtn');
    this.email = this.querySelector('[name="customer[email]"]');
    this.confirm_email = this.querySelector('[name="customer[confirm_email]"]');
    this.mobileNo = this.querySelector('#mobile');
    this.capturedValue = this.querySelector('#capturedValue');
    this.capturedValuemob = this.querySelector('#capturedValuemob');
    this.lastOTPDigit = this.querySelector('#OneTimePassword6');
    this.user_id = getCookie('user_id');
    this.username = '';

    this.evenetListener();
  }
  evenetListener() {

    // validate mobile number
    this.mobileNo.addEventListener('keypress', e => {
      var numericValue = this.mobileNo.value.replace(/\D/g, '');
      this.mobileNo.value = numericValue;
      if (numericValue.length >= 8) {
        this.verifyMobileBtn.removeAttribute('disabled');
      } else {
        this.verifyMobileBtn.setAttribute('disabled', 'disabled');
      }    
      if (e.key === 'Enter') {
        showLoader();
        this.verifyMobileBtn.click();
      }
    });
        // Assuming this.verifyMobileBtn is your button element
      const verifyMobileBtn = document.getElementById('verifyMobile');
      const verifyOtpLoginBtn = document.querySelector('.verifyOtpLoginBtn');
      
      const loader = document.getElementById('loader');      
      const loaderotp = document.getElementById('loaderotp');
     

    verifyMobileBtn.addEventListener('click', () => {
             showLoader();   
        });
    
    // Function to show the loader
function showLoader() { 
  verifyMobileBtn.querySelector('span').style.display = 'none';
    loader.style.display = 'block';    
}

    // send opt on mobile number and visible enter otp form
    this.verifyMobileBtn.addEventListener('click', e => {
      sendOTP(this.mobileNo.value).then(response => {
        console.log('Send Login OTP',response);
        this.capturedValue.innerHTML = this.mobileNo.value;
        this.capturedValuemob.innerHTML = this.mobileNo.value;
        this.startTimer();
        if (this.customLoginElement.style.display === 'none' || this.customLoginElement.style.display === '') {
            this.customLoginElement.style.display = 'block';
            this.customLoginotpElement.style.display = 'none';
        } else {
            this.customLoginElement.style.display = 'none';
            this.customLoginotpElement.style.display = 'block';
        }
      });
    });
      
      verifyOtpLoginBtn.addEventListener('click', () => {
        showLoaderotp();
      });


    // resend otp on mobile number
    this.resendBtn.addEventListener('click', e => {
      sendOTP(this.mobileNo.value).then(response => {
        console.log('Resend Login OTP',response);
        this.resendBtn.classList.add('disabled-link');
        this.startTimer();
      });
    });


    // verify otp to login
    this.verifyOtpLoginBtn.addEventListener('click', e => {
      let OTP = this.querySelector('#OneTimePassword1').value+this.querySelector('#OneTimePassword2').value+this.querySelector('#OneTimePassword3').value+this.querySelector('#OneTimePassword4').value+this.querySelector('#OneTimePassword5').value+this.querySelector('#OneTimePassword6').value;
      var formdata = new FormData();
      formdata.append("mobileNo", this.mobileNo.value);
      formdata.append("otp", OTP);
      fetch(`https://alainappuat.gdadmin.org/shopifyApiV2/verifyOtp`, {
        method: 'POST',
        headers:{
          'lancode':'en',
          'token':'123456'
        },
        body:formdata,
      })
      .then(response => {
        if (!response.ok) {
        this.querySelector("#invalidOTPError").innerText = "Invalid OTP.";
        hideLoaderotp();
        throw new Error(`Network response was not ok: ${response.status}`);
      }
        return response.json();
      })
      .then(data => {
        console.log('Verified OTP',data);
        if(Array.isArray(data.response) && data.response != '' && data.response != null){
          console.log('Customer Email ID',data.response['0'].email_id);
          this.user_id = data.response['0'].id;
          this.username = data.response['0'].name;
          if(data.response['0'].email_id == "" || data.response['0'].email_id == null){
            this.customEmailElement.style.display = 'block';
            this.customLoginElement.style.display = 'none';
          }else{
            setCookie('user_id',data.response['0'].id);
            const responseData = data.response['0'];
            this.customerLogin(JSON.stringify({email:responseData.email_id,name:this.username,user_id:this.user_id,phone:responseData.phoneNo,address1:responseData.address,city:responseData.cityName,province:responseData.districtName,country:responseData.country,zip:responseData.zipcode}));
          }
        }else{
          this.querySelector("#invalidOTPError").innerText = "Invalid OTP.";
           hideLoaderotp();
        }
      }).catch(error => {
        console.log('Fetching error verify OTP',error);
      });
    });

        // Function to show the loader
      function showLoaderotp() { 
        verifyOtpLoginBtn.querySelector('span').style.display = 'none';          
          loaderotp.style.display = 'block';              
      }
       function showLoaderemail() { 
        updateEmailBtn.querySelector('span').style.display = 'none';          
          loaderemail.style.display = 'block';              
      }

      // Function to hide the loader
      function hideLoaderotp() { 
        document.getElementById('loaderotp').style.display = 'none';
        verifyOtpLoginBtn.querySelector('span').style.display = 'block'; 
      }

    this.querySelector('#OneTimePassword6').addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        showLoaderotp();
        this.verifyOtpLoginBtn.click();
      }
    });

    this.updateEmailBtn.addEventListener('click', e => {
      showLoaderemail();
      if(this.validateForm && this.isValidEmail() && this.validateConfirmEmailField()){
        this.updateEmailAddress();       
      }
    });
  }

  startTimer() {
    var timeLeft = 60;
    var timerElement = document.getElementById('timer');
    var timer = setInterval(function () {
        let minutes = Math.floor(timeLeft / 60);
        let seconds = timeLeft % 60;
        let formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        timerElement.textContent = formattedTime;
        if (--timeLeft <= 0) {
            clearInterval(timer);
            // Enable the link and reset onclick when the timer finishes
            document.getElementById('resendLink').classList.remove('disabled-link');
            timerElement.style.display = 'none';
        }else{
          timerElement.style.display = 'block';
        }
    }, 1000);
  }
  customerLogin(jsondata) {
    fetch(`https://alainuat.gdadmin.org/laravel/public/api/customer/login/${jsondata}`, {
        method: 'GET',
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        console.log('Token',data);
        window.location = `/account/login/multipass/${data.token}`;
    })
    .catch(error => {
        console.error('Error fetching data:', error);
    });
  }
  validateForm(){
    this.querySelector('#emailError').innerText = "";
    if(this.email.value == '' || this.email.value == null){
      this.querySelector('#emailError').innerText = "Please enter your email.";
      return false;
    }
    return true;
  }
  isValidEmail() {
    // More permissive email validation regex
    this.emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    this.querySelector('#emailError').innerText = "";
    if(!this.emailRegex.test(this.email.value)){
      this.querySelector('#emailError').innerText = "Please enter a valid Email Address.";
      return false;
    }
    return true;
  }
  validateConfirmEmailField() {
    this.input = this.querySelector('[name="customer[confirm_email]"]');
    this.errorElement = document.getElementById('confirmEmailError');
    this.confirmEmail = this.input.value.trim();
    this.referenceEmail = this.querySelector('[name="customer[email]"]').value.trim();

    if (this.confirmEmail === '' || this.confirmEmail !== this.referenceEmail) {
        this.errorElement.innerHTML = 'Email Addresses does not match.';
        console.error('Email Addresses does not match.');
        return false;
    } else {
        this.errorElement.innerHTML = '';
        return true;
    }
  }
  updateEmailAddress() {
    var myHeaders = new Headers();
    myHeaders.append("token", "123456");
    myHeaders.append("lancode", "en");
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify({email_id:this.email.value,user_id:this.user_id});
    fetch(`https://alainappuat.gdadmin.org/shopifyApiV2/updateEmailAddress`, {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    })
    .then(response => response.text())
    .then(data => {
      console.log('Update Email',data);
      if(data.responce)
        this.querySelector('#confirmEmailError').innerText = "Something went wrong. Please try again latter!"
      else
        this.customerLogin(JSON.stringify({email:this.email.value,name:this.username,user_id:this.user_id}));
    }).catch(error => console.log('Error fetching data:',error));
  }
}
customElements.define('login-customer',LoginCustomer);